export const partition = <T>(arr: Array<T>, size: number): Array<Array<T>> => {
  const res: Array<Array<T>> = [];
  while (arr.length > 0) {
    const chunk = arr.splice(0, size);
    res.push(chunk);
  }
  return res;
};
